// extracted by mini-css-extract-plugin
export default {"hide_tablet":"CoinsOwnedTable_hide_tablet__ap53Q","hide_mobile":"CoinsOwnedTable_hide_mobile__JGbqr"};